/* tslint:disable */
/* eslint-disable */

/**
 * 0 = AsIs
 * 
 * 1 = Repair
 * 
 * 2 = Rma
 * 
 * 3 = Scrap
 */
export enum DamageDisposition {
  AsIs = 0,
  Repair = 1,
  Rma = 2,
  Scrap = 3
}
